import axios from "axios";
import {
  COUPONS_URL,
  ORDER_URL,
  CASE_URL,
  PARTNER_URL,
  BASE_URL,
  AUTH_URL,
  MD_URL,
  USER_URL,
  STRIPE_URL,
  BILLING_URL,
  RECOMMENDATION_URL,
  CONDITION_URL,
  LAB_EXAM_URL,
  MEDICATIONS_URL,
  ADDRESS_URL,
} from "../utils/constantsEnv";

export const runwayApi = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

let authHandlers = null;

export const configureAuth = (handlers) => {
  authHandlers = handlers;
};

//auth
//POST   login, register, restorePassword, updatePassword
//GET changePassword
const authPost = async (path, data) => {
  return await runwayApi.post(`${AUTH_URL}${path}`, data, {});
};
const authPut = async (path, data) => {
  return await runwayApi.put(`${AUTH_URL}${path}`, data, {});
};
const authGet = async (path) => {
  return await runwayApi.get(`${AUTH_URL}${path}`, {
    params: { token: localStorage.getItem("token") },
  });
};
const authDelete = async (path) => {
  return await runwayApi.delete(`${AUTH_URL}${path}`);
};
const authPublicGet = async (path) => {
  return await runwayApi.get(`${AUTH_URL}${path}`);
};
export const auth = {
  authPost,
  authPut,
  authGet,
  authDelete,
  authPublicGet,
};

//MD POST
//upload_file, create_case, get_patient_cases, cancel_case, update_case_prescriptions, get_case_prescriptions,
//get_messages, create_message, update_messages, set_message_as_read

const mdPost = async (path, data) => {
  let payload = data;
  if (path === "upload_file") {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("file", data.file);
    formData.append("path", data.filePath);
    payload = formData;
  }
  return await runwayApi.post(`${MD_URL}${path}`, payload, {});
};

export const md = {
  mdPost,
};

// STRIPE
//GET  get_plans, get_subscriptions
//POST  pay, buy_plan, cancel_subscriptions
const stripePost = async (path, data) => {
  return await runwayApi.post(`${process.env.REACT_APP_STRIPE_URL}${path}`, data, {});
};
const stripeGet = async (path) => {
  return await runwayApi.get(`${STRIPE_URL}${path}`, {});
};
export const stripe = {
  stripePost,
  stripeGet,
};

// CONDITION
// POST search
const conditionPost = async (path, data) => {
  return await runwayApi.post(`${CONDITION_URL}${path}`, data, {});
};

// GET
// `config` is forwarded as-is (e.g. a `timeout`) -- same convention as
// medicationsGet / addressGet / recommendationPost.
const conditionGet = async (path, config) => {
  return await runwayApi.get(`${CONDITION_URL}${path}`, config);
};

export const condition = {
  conditionPost,
  conditionGet,
};

// MEDICATIONS
// GET search
// `config` is forwarded as-is (e.g. an AbortController `signal`) -- unlike
// conditionGet, callers of this endpoint need per-request cancellation.
const medicationsGet = async (path, config) => {
  return await runwayApi.get(`${MEDICATIONS_URL}${path}`, config);
};

export const medications = {
  medicationsGet,
};

// ADDRESS
// GET search
// `config` is forwarded as-is (e.g. an AbortController `signal`) -- same
// per-request-cancellation need as medicationsGet.
const addressGet = async (path, config) => {
  return await runwayApi.get(`${ADDRESS_URL}${path}`, config);
};

export const address = {
  addressGet,
};

//USER
// POST treatment, intakeform
// GET  treatment
// PATCH  updateInfo
const userGet = async (path) => {
  return await runwayApi.get(`${USER_URL}${path}`, {});
};
const userPatch = async (path, data) => {
  return await runwayApi.patch(`${USER_URL}${path}`, data, {});
};
const userPost = async (path, data) => {
  return await runwayApi.post(`${USER_URL}${path}`, data, {});
};
const userPut = async (path, data) => {
  return await runwayApi.put(`${USER_URL}${path}`, data, {});
};
const userDelete = async (path) => {
  return await runwayApi.delete(`${USER_URL}${path}`);
};
// BILLING
const billingGet = async (path, config = {}) => {
  return await runwayApi.get(`${BILLING_URL}${path}`, config);
};

// GET partner
const partnerGet = async (path) => {
  return await runwayApi.get(`${PARTNER_URL}${path}`);
};

// POST partner
const partnerPost = async (path, data) => {
  return await runwayApi.post(`${PARTNER_URL}${path}`, data);
};

// PUT partner
const partnerPut = async (path, data) => {
  return await runwayApi.put(`${PARTNER_URL}${path}`, data);
};

// DELETE partner
const partnerDelete = async (path) => {
  return await runwayApi.delete(`${PARTNER_URL}${path}`);
};

// COUPONS
// GET promo_code
const couponGet = async (path) => {
  return await runwayApi.get(`${COUPONS_URL}${path}`, {});
};

export const coupons = {
  couponGet,
};

// CASES
const casePost = async (path, data) => {
  return await runwayApi.post(`${CASE_URL}${path}`, data, {});
};

const casePut = async (path, data) => {
  return await runwayApi.put(`${CASE_URL}${path}`, data, {});
};

const caseGet = async (path) => {
  return await runwayApi.get(`${CASE_URL}${path}`, {});
};

export const cases = {
  casePost,
  casePut,
  caseGet,
};

// SEARCH
export const search = async (path, data) => {
  return await runwayApi.get(`/v1/search/${path}`, data);
};

const orderGet = async (path, config = {}) => {
  return await runwayApi.get(`${ORDER_URL}${path}`, config);
};

const orderPost = async (path, data) => {
  return await runwayApi.post(`${ORDER_URL}${path}`, data, {});
};

const orderPut = async (path, data) => {
  return await runwayApi.put(`${ORDER_URL}${path}`, data, {});
};

const orderDelete = async (path) => {
  return await runwayApi.delete(`${ORDER_URL}${path}`, {});
};

export const order = {
  orderGet,
  orderPost,
  orderPut,
  orderDelete,
};

// RECOMMENDATIONS
// `config` is forwarded as-is (e.g. a `timeout`) -- same convention as
// medicationsGet / addressGet.
const recommendationPost = async (path, data, config) => {
  return await runwayApi.post(`${RECOMMENDATION_URL}${path}`, data, config);
};

export const recommendations = {
  recommendationPost,
};

// LAB EXAM
const labExamPost = async (path, data) => {
  return await runwayApi.post(`${LAB_EXAM_URL}${path}`, data, {});
};

export const labExam = {
  labExamPost,
};

runwayApi.interceptors.request.use(
  (config) => {
    config.headers["x-access-token"] = localStorage.getItem("token");
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export const createTokenRefreshHandler = (getAuthHandlers, apiInstance, authUrl) => {
  return async (error) => {
    const originalRequest = error.config;
    const isRefreshEndpoint = originalRequest?.url === `${authUrl}refresh`;
    // A 401 from login means wrong credentials, not an expired session.
    const isLoginEndpoint = originalRequest?.url === `${authUrl}login`;
    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry &&
      !isRefreshEndpoint &&
      !isLoginEndpoint
    ) {
      originalRequest._isRetry = true;
      try {
        const response = await apiInstance.post(`${authUrl}refresh`);
        localStorage.setItem("token", response.data.token);
        return apiInstance.request(originalRequest);
      } catch (refreshError) {
        const handlers = getAuthHandlers();
        if (handlers) {
          handlers.handleSessionExpired();
        }
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  };
};

runwayApi.interceptors.response.use(
  (config) => config,
  createTokenRefreshHandler(() => authHandlers, runwayApi, AUTH_URL)
);

export const user = {
  userGet,
  userPatch,
  userPost,
  userPut,
  userDelete,
};

export const admin = {
  partnerGet,
  partnerPost,
  partnerPut,
  partnerDelete,
};

export const billing = {
  billingGet,
};
